module.exports = __webpack_public_path__ + "static/media/img-floor-1.006bcaa0.png";